import StatusBlock from "../components/statusBlock";
import { Helmet } from "react-helmet";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import CartController from "../controllers/cartController";
import SuccessPaymentActions from "../components/successPaymentActions";
import SuccessOrderInfo from "../components/successOrderInfo";

const SuccessPage = () => {
  const [params] = useSearchParams();
  const orderNumber = params.get("orderId");
  const [order, setOrder] = useState(null);
  const [isOrderLoading, setIsOrderLoading] = useState(Boolean(orderNumber));

  const { formData } = useSelector((state) => state.cart);

  const paymentMethod = order?.paymentMethod || formData.paymentMethod;
  const isCardPayment = paymentMethod === "CARD";

  useEffect(() => {
    const loadOrder = async () => {
      if (!orderNumber) {
        setIsOrderLoading(false);
        return;
      }

      const result = await CartController.getOrder(orderNumber);

      if (result.success) {
        setOrder(result.data);
      }

      setIsOrderLoading(false);
    };

    loadOrder();
  }, [orderNumber]);

  return (
    <>
      <Helmet>
        <title>Заявка отправлена</title>
      </Helmet>
      <StatusBlock
        icon="check-alt"
        title="Заявка отправлена"
        text="Наши менеджеры свяжутся с вами в ближайшее время."
        btn={
          !isOrderLoading ? (
            <SuccessOrderInfo
              order={order}
              orderNumber={orderNumber}
              paymentMethod={paymentMethod}
            >
              {isCardPayment && order?.paymentStatus !== "PAID" ? (
                <SuccessPaymentActions orderNumber={orderNumber} />
              ) : null}
            </SuccessOrderInfo>
          ) : null
        }
      />
    </>
  );
};

export default SuccessPage;
